import React from "react";
import { MessagingContext } from "../context/messaging-layer";
import fieldPropTypes from "./field-prop-types";
import { handleClickEvent } from "../utils/click-event-utils";

class CallToActionButton extends React.Component {
  // this method is not used anymore,
  // we should consider removing it to avoid confusion
  handleButtonClickWrapper = () => {
    const {
      field: { name, text, title, action, __noValidation },
      appData,
      screen
    } = this.props;
    const { screenRef } = appData;
    const theAction = action ?? screen.action;

    if (theAction?.type === "alert_url") {
      theAction.type = "url";
    }

    if (action?.type === "pop_screen") {
      return appData.handleBackButtonClick();
    }

    // The validation should be skipped in two cases:
    // 1. The action to be executed either has no 'needsValidation' property
    //    defined or the property is set to 'false'
    // 2. A special property called '__noValidation' is defined on the field
    //    and is set to 'true'
    const skipValidation = !theAction?.needsValidation || __noValidation;
    const isDfd = appData.properLink;

    const { field } = this.props;
    const onClickEventStates = getFieldActionEventStates(
      field,
      actionEventsMap.onClick
    );
    appData.updateStates(onClickEventStates, true);

    if (skipValidation || isFieldsValid(appData)) {
      if (onClickEventStates && !action?.value) {
        return;
      }

      if (name === "member_attachment_id") {
        appData.handleButtonClick(name, title.split("\n\n")[0], theAction);
      } else {
        appData.handleButtonClick(name, text, theAction);
      }
    } else {
      if (isDfd || action?.show_error_toast) {
        appData.screenValidation.setScreenValidity();
      }
      if (screenRef?.current?.scrollIntoView) {
        screenRef.current.focus();
        screenRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }
  };

  handleClick = () => {
    const {
      context,
      props: { field, appData, screen }
    } = this;

    handleClickEvent(field, screen, appData, context);
  };

  formLabel = title => {
    const { name } = this.props.field;
    if (title.includes("\n")) {
      const [header, ...content] = title.split("\n");

      return (
        <span className='button-text-wrapper-web-sdk'>
          <span className='button-text-header-web-sdk'>{header}</span>
          <span className='button-text-label-web-sdk'>
            {content.join("\n")}
          </span>
        </span>
      );
    } else if (
      /* We get uppercase string from backend so we have to transform it to lowercase to make it capitalize by css */
      (name === "continueButton" ||
        name === "continue" ||
        name === "return_to_home_btn" ||
        name === "provider_selection_mode_code") &&
      title === title.toUpperCase()
    ) {
      return title.toLowerCase();
    } else {
      return title;
    }
  };

  buildClasses = () => {
    const { field } = this.props;
    let classes = "";

    if (field.params.includes("TDFieldOptionSecondaryAction")) {
      classes += "secondary ";
    }
    if (field?.layout?.visible === false) {
      classes += "hidden-field";
    }
    return classes;
  };

  render() {
    const {
      field,
      lastOfKind,
      onlyOfKind,
      components: { Button, MemberAttachment, Spinner },
      appData: {
        callToActionButton: { isLoading },
        settings
      }
    } = this.props;
    const buttonIsLoading = isLoading && isLoading.includes(field.name);

    if (field.name.includes("member_attachment"))
      return (
        <MemberAttachment
          title={field.title.split("\n\n")[0]}
          description={field.title.split("\n\n")[1]}
          action={field.action}
          onClick={this.handleClick}
          settings={settings}
        />
      );

    const renderButton = () => {
      const disabled = field.params.includes("TDFieldOptionDisabled");
      const isUITimer =
        field.params.includes("TDFieldOptionUItimer") &&
        new Date(field?.data?.ui_timer_values?.enable_timestamp) > new Date();

      const { isItemSelected } = this.props.appData;

      return (
        <Button
          name={field.name}
          text={field.text}
          className={this.buildClasses()}
          params={field.params}
          data={field.data}
          label={this.formLabel(field.title ?? "")}
          onClick={this.handleClick}
          lastOfKind={lastOfKind}
          onlyOfKind={onlyOfKind}
          disabled={
            field.name === "share_and_continue_disabled" ||
            disabled ||
            field.disabled ||
            field.params.includes("TDFieldOptionIsInactive") ||
            isItemSelected ||
            buttonIsLoading ||
            isUITimer
          }
          isLoading={buttonIsLoading}
        />
      );
    };

    return !buttonIsLoading ? (
      renderButton()
    ) : (
      <div className='websdk-flex'>
        {renderButton()}
        <Spinner className='call-to-action-button__spinner' />
      </div>
    );
  }
}

CallToActionButton.propTypes = fieldPropTypes;
CallToActionButton.contextType = MessagingContext;

export default CallToActionButton;
